import React, { Fragment, useEffect, useState } from "react";
import { ConfirmAppointmentSuccess } from "./ConfirmAppoinmentSuccess";
import { ConfirmAppointmentFailure } from "./ConfirmAppointmentFailure";
import { ConfirmAppointmentWaiting } from "./ConfirmAppointmentWaiting";
import queryString from "query-string";
import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import * as ContactingApi from "../../../Requests/contactingAPIs";
import { useHistory } from "react-router-dom";

export function ConfirmAppointment(params) {
  // const [accessToken, setAccessToken] = useState(null);
  const [isAppointmentConfirmed, setIsAppointmentConfirmed] = useState({});
  const [statusMessage, setStatusMessage] = useState({});
  const [openDialog, setOpenDialog] = useState(true);
  const { push } = useHistory();

  const value = queryString.parse(window.location.search);
  const appointmentUID = value.appointmentUID;

  const ConfirmAppointment = async () => {
    setIsAppointmentConfirmed(null);
    const confirmAppointmentResult = await ContactingApi.manageAppointment(
      appointmentUID,
      "ConfirmAppointment"
    );
    try {
      if (confirmAppointmentResult != null) {
        if (confirmAppointmentResult.StatusCode === 200) {
          setStatusMessage(confirmAppointmentResult.statusMessage);
          setIsAppointmentConfirmed(200);
        } else {
          setStatusMessage(confirmAppointmentResult.statusMessage);
          setIsAppointmentConfirmed(400);
        }
      } else {
        setIsAppointmentConfirmed(null);
      }
    } catch (e) {
      setStatusMessage(e);
    }
  };

  useEffect(() => {
    document.title = "Connect Health | Confirm Appointment";
  }, []);

  const handleClose = (answer) => {
    if (answer === "Agree") {
      ConfirmAppointment();
      setOpenDialog(false);
    } else if (answer === "Disagree") {
      push(`/Appointments/AppointmentBooking?appointmentUID=${appointmentUID}`);
    }
  };

  return (
    <Fragment>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm your appointment?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to confirm your appointment.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose("Disagree")}
            color="secondary"
            variant="contained"
          >
            No
          </Button>
          <Button
            onClick={() => handleClose("Agree")}
            color="primary"
            autoFocus
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {isAppointmentConfirmed === 200 && (
        <Paper
          sx={{
            padding: {
              xs: 0,
              sm: 3,
              md: 5,
            },
            paddingBottom: {
              xs: 5,
            },
          }}
        >
          <ConfirmAppointmentSuccess result={statusMessage} />
        </Paper>
      )}
      {(isAppointmentConfirmed === 400 || isAppointmentConfirmed === 403) && (
        <Paper
          sx={{
            padding: {
              xs: 0,
              sm: 3,
              md: 5,
            },
            paddingBottom: {
              xs: 5,
            },
          }}
        >
          <ConfirmAppointmentFailure result={statusMessage} />
        </Paper>
      )}
      {isAppointmentConfirmed === null && <ConfirmAppointmentWaiting />}
    </Fragment>
  );
}
